/**
 * English UI strings for the trade / create transaction page (swap for i18n later).
 */
export const createTransactionCopy = {
  receiptPdfFailed: 'Failed to generate receipt PDF',
} as const
